window.$ = window.jQuery = require('jquery');
require('./animations');
require('./lightbox');
require('./nav');
require('./slider');
require('./slider-settings');
require('./accordion');